// extracted by mini-css-extract-plugin
export var buttonContainer = "ButtonPanel-module--buttonContainer--5ee3c";
export var cyan = "ButtonPanel-module--cyan--1f180";
export var orange = "ButtonPanel-module--orange--a87fd";
export var pink = "ButtonPanel-module--pink--49edd";
export var purple = "ButtonPanel-module--purple--03158";
export var red = "ButtonPanel-module--red--d9386";
export var root = "ButtonPanel-module--root--e22ed";
export var smallWrap = "ButtonPanel-module--smallWrap--4a18d";